import { useEffect, useState } from "react";
import { config } from "../../utils/config";
import {
  fetchDataAndMapToField,
  waitForCookie,
} from "../../utils/helperFuctions";

const useUsersLogic = () => {
  const initFields = [
    {
      name: "first_name",
      label: "First name",
      type: "text",
      isRequired: true,
      err: "Name is required",
      span: 3,
    },
    {
      name: "last_name",
      label: "Last name",
      type: "text",
      isRequired: true,
      err: "Name is required",
      span: 3,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      err: "Email is required",
      isRequired: true,
      span: 3,
    },
    {
      name: "password",
      label: "Password",
      type: "text",
      err: "Password is required",
      isRequired: true,
      span: 3,
    },
    {
      name: "role",
      label: "Role",
      type: "dropdown",
      isRequired: true,
      err: "Role is required",
      returnID: true,
      span: 3,
    },
    {
      name: "signature",
      type: "esignature",
      label: "User's signature",
      // hideButton: true,
      span: 6,
    },
    // Add more fields as needed
  ];

  //Roles
  //const captain = process.env.REACT_APP_CAPTAIN_ID;
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin];
  const deleteRoles = [admin];
  const editRoles = [admin];

  const tabs = [
    {
      name: "Details",
      href: "#",
      current: true,
      fields: [
        "first_name",
        "last_name",
        "email",
        "role",
        "password",
        "signature",
      ],
      allowedRoles: [admin],
    },
  ];

  const [fields, setfields] = useState(initFields);
  const [tabsData, setTabsData] = useState([]);
  const apiRoute = "users";
  const onlyForm = undefined;

  useEffect(() => {
    var interval = setInterval(async function () {
      const currentRole = await waitForCookie("_r");
      // Check if the variable is loaded
      if (currentRole) {
        const __tabs = tabs.filter((x) => x.allowedRoles.includes(currentRole));
        if (__tabs?.length > 0) {
          __tabs[0].current = true;
        }
        setTabsData(__tabs);
        // Delete the interval
        clearInterval(interval);
      }
    }, 100); // Check every 100 milliseconds

    return () => {
      setTabsData([]);
    };
  }, []);
  const getPromises = (temp) => {
    return [fetchDataAndMapToField(config, "roles", "role", temp)];
  };
  return {
    apiRoute,
    initFields,
    onlyForm,
    getPromises,
    tabs,
    tabsData,
    addRoles,
    deleteRoles,
    editRoles,
  };
};

export default useUsersLogic;
